import grapesjs from "grapesjs";
import { getPageUrl, setToken } from "./lib/pageUrl";
import storageManager from "./storageManager";
import assetManager, { plugin as assetManagerPlugin } from "./assetManager";
import blocks from "./blocks";
import metaEditor from "./plugins/MetaEditor";
import pageScriptEditor from "./plugins/PageScriptEditor";
import richTextEditor from "./plugins/RichTextEditor";
import colorEditor from "./plugins/ColorEditor";
import faqAccordion from "./plugins/FaqAccordion";

const myPlugin = editor => {
  editor.StyleManager.addBuiltIn("custom-background-color", {
    type: "radio",
    label: "Background color",
    property: "background-color",
    default: "#FFFFFF",
    options: [
      { id: "#FFFFFF", label: "White" },
      { id: "#F5F6F7", label: "Gray" },
    ],
  });
};

const pageUrl = getPageUrl();
setToken();

grapesjs.init({
  container: ".gjs__editor",
  fromElement: false,
  height: "100vh",
  width: "auto",
  parser: {
    parserHtml: str => {
      const el = new DOMParser().parseFromString("", "text/html").createElement("div");
      el.innerHTML = str;
      return el;
    },
  },
  plugins: [
    storageManager,
    blocks,
    metaEditor,
    pageScriptEditor,
    colorEditor,
    assetManagerPlugin,
    richTextEditor,
    faqAccordion,
    myPlugin,
  ],
  assetManager,
  storageManager: {
    id: "",
    type: "remote-file",
    autosave: true,
    autoload: true,
    stepsBeforeSave: true,
    storeComponents: true,
    storeStyles: true,
    storeHtml: true,
    storeCss: true,
    urlStore: pageUrl,
    urlLoad: pageUrl,
  },
  styleManager: {
    sectors: [
      {
        name: "General",
        open: false,
        properties: ["display", "float", "position", "top", "right", "left", "bottom"],
      },
      {
        name: "Flex",
        open: false,
        properties: [
          "flex-direction",
          "flex-wrap",
          "justify-content",
          "align-items",
          "align-content",
          "order",
          "flex-basis",
          "flex-grow",
          "flex-shrink",
          "align-self",
        ],
      },
      {
        name: "Dimension",
        open: false,
        properties: ["width", "height", "max-width", "min-height", "margin", "padding"],
      },
      {
        name: "Typography",
        open: false,
        properties: [
          "font-family",
          "font-size",
          "font-weight",
          "letter-spacing",
          "color",
          "line-height",
          "text-align",
          "text-shadow",
        ],
      },
      {
        name: "Decorations",
        open: false,
        properties: ["background-color", "border-radius", "border", "box-shadow", "background"],
      },
      {
        name: "Extra",
        open: false,
        properties: ["opacity", "transition", "transform"],
      },
      {
        name: "Component Styles",
        open: true,
        properties: ["custom-background-color"],
      },
    ],
  },
});
